import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSearchSettings} from 'src/openapi/admin/apis/ConferenceSearchSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    conferenceId: number,
};

export const useGetSearches = ({conferenceId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getSearchSettings({conferenceId}, {signal}),
    ), [conferenceId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
